<main>
  <section>
    <ng-content></ng-content>
  </section>
</main>
